const _excluded = ["connection", "indexName", "searchSettings", "requestOptions", "routing", "analytics", "className", "onlyFetchWithQuery", "onlyFetchWithQueryFunction", "children", "hitsPerPage"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Client from '@searchkit/instantsearch-client';
import c from 'classnames';
import { Configure, InstantSearch } from 'react-instantsearch';
import Searchkit from 'searchkit';
import AnalyticsHandler from '../Analytics';
import { DEFAULT_HITS_PER_PAGE, DEFAULT_REQUEST_OPTIONS } from '../../config/constants';

// Omit `searchClient` when extending the InstantSearchProps.
// We do that because we calculate the searchClient in this component
// and pass it to the <InstantSearch> wrapper anyways.

const SearchkitWrapper = _ref => {
  let {
      connection,
      indexName,
      searchSettings,
      requestOptions = DEFAULT_REQUEST_OPTIONS,
      routing = false,
      analytics = false,
      className,
      onlyFetchWithQuery,
      onlyFetchWithQueryFunction = requests => requests.some(_ref2 => {
        let {
          params: {
            query
          } = {}
        } = _ref2;
        return query !== undefined && query !== '';
      }),
      children,
      hitsPerPage = DEFAULT_HITS_PER_PAGE
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const classNames = c('Searchkit', className);
  const searchClient = React.useMemo(() => {
    const sk = new Searchkit({
      connection,
      search_settings: searchSettings
    });
    const client = Client(sk, requestOptions);
    if (!onlyFetchWithQuery) {
      // Skip the overriding of the search function below.
      return client;
    }
    return _objectSpread(_objectSpread({}, client), {}, {
      search: requests => {
        // Only search if we actually have a query value.
        // This prevents an inital empty call from being executed, leading to a worse page speed.
        // NB: This functionality may break things, like facet filter search.
        if (onlyFetchWithQueryFunction(requests)) {
          return client.search(requests);
        }
        return Promise.resolve({
          results: [{
            hits: []
          }]
        });
      }
    });
  }, [connection, searchSettings, requestOptions, onlyFetchWithQuery, onlyFetchWithQueryFunction]);
  const searchParameters = {};
  if (hitsPerPage > 0) {
    searchParameters.hitsPerPage = hitsPerPage;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(InstantSearch, _extends({}, restProps, {
    indexName: indexName,
    searchClient: searchClient,
    routing: routing
  }), analytics && /*#__PURE__*/React.createElement(AnalyticsHandler, {
    indexName: indexName
  }), /*#__PURE__*/React.createElement(Configure, searchParameters), children));
};
export default SearchkitWrapper;